export class ChaseDetailForAuditItem {
  action: string;
  auditPackageId: number;
  auditPackageIds?: number[];
  auditPackageItemId?: number;
  auditReady?: string;
  chaseId: number;
  cmsModel?: string;
  diagnosisPageNumber?: number;
  encounterType?: string;
  entityId?: number;
  hccCode?: string;
  hccValidationResult?: string;
  icdCode?: string;
  measureCode: string;
  measureId: number;
  memberDOB: string;
  memberFirstName: string;
  memberId: number;
  memberLastName: string;
  numeratorCode: string;
  numeratorId: number;
  numeratorName: string;
  paymentYear?: number;
  planId?: string;
  product?: string;
  projectId: number;
  status?: string;
  templateId?: number;
  userRank?: number;

  constructor(options: Partial<ChaseDetailForAuditItem> = {}) {
    this.action = options.action;
    this.auditPackageId = options.auditPackageId;
    this.auditPackageIds = options.auditPackageIds;
    this.auditPackageItemId = options.auditPackageItemId;
    this.auditReady = options.auditReady;
    this.chaseId = options.chaseId;
    this.cmsModel = options.cmsModel;
    this.diagnosisPageNumber = options.diagnosisPageNumber;
    this.encounterType = options.encounterType;
    this.entityId = options.entityId;
    this.hccCode = options.hccCode;
    this.hccValidationResult = options.hccValidationResult;
    this.icdCode = options.icdCode;
    this.measureCode = options.measureCode;
    this.measureId = options.measureId;
    this.memberDOB = options.memberDOB;
    this.memberFirstName = options.memberFirstName;
    this.memberId = options.memberId;
    this.memberLastName = options.memberLastName;
    this.numeratorCode = options.numeratorCode;
    this.numeratorId = options.numeratorId;
    this.paymentYear = options.paymentYear;
    this.planId = options.planId;
    this.product = options.product;
    this.projectId = options.projectId;
    this.status = options.status;
    this.templateId = options.templateId;
    this.userRank = options.userRank;
  }

  toApiRequest(): any {
    return {
      Action: this.action,
      AuditPackageId: this.auditPackageId,
      AuditPackageIds: this.auditPackageIds,
      AuditPackageItemId: this.auditPackageItemId,
      AuditReady: this.auditReady,
      ChaseId: this.chaseId,
      DiagnosisPageNumber: this.diagnosisPageNumber,
      MeasureCode: this.measureCode,
      MeasureId: this.measureId,
      MemberDOB: this.memberDOB,
      MemberFirstName: this.memberFirstName,
      MemberId: this.memberId,
      MemberLastName: this.memberLastName,
      NumeratorCode: this.numeratorCode,
      NumeratorId: this.numeratorId,
      EntityId: this.entityId,
      ProjectId: this.projectId,
      UserRank: this.userRank,
      Status: this.status,
      IcdCode: this.icdCode,
      HccCode: this.hccCode,
      CmsModel: this.cmsModel,
      EncounterTypeXml: this.encounterType,
      PaymentYear: this.paymentYear,
      PlanId: this.planId,
      Product: this.product,
      HccValidationResult: this.hccValidationResult,
    };
  }
}
